export default __webpack_public_path__ + "static/media/Starry_color.e3128d2d.png";